import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Landing from "./Landing";
import PrivateRoute from "./PrivateRoute";
import Home from './Home';
import TestMarquees from './TestMarquees';
import EventCalendar from './EventCalendar';
import TestCalendar from './TestCalendar';
import Containers from './Containers';
import { AuthProvider, useAuth } from "./AuthContext";
import DevLogin from "./DevLogin"; // Ensure this component exists

function AppContent() {
  const { showDevLogin, isLocalhost } = useAuth();

  return (
    <>
      {isLocalhost && showDevLogin && <DevLogin />}
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/marquee" element={<PrivateRoute><TestMarquees /></PrivateRoute>} />
          <Route path="/containers" element={<PrivateRoute><Containers /></PrivateRoute>} />
          <Route path="/test-calendar" element={<PrivateRoute><TestCalendar /></PrivateRoute>} />
          <Route path="/event-calendar" element={<PrivateRoute><EventCalendar /></PrivateRoute>} />
        </Routes>
      </Router>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;